export default __webpack_public_path__ + "images/c032795057532003af70985bb6945bb8-exercise.webp";